import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateSlot, Tooltip } from '../interfaces';
import { FlowConstants, TranslationUtils } from '../utils';
import { ContextModelService } from '../services';

@Pipe({
    name: 'slotTooltip'
})
export class SlotTooltipPipe implements PipeTransform {
    public translate = inject(TranslateService);
    private contextModel = inject(ContextModelService);

    transform(slot: TemplateSlot, value?: string | number | boolean): Tooltip | undefined {
        if (!slot.tooltip) {
            return undefined;
        }

        let contentKey = slot.tooltip.contentKey;
        const contentData = slot.tooltip.contentData;
        let icon = slot.tooltip.icon;
        if (typeof value === 'string' || typeof value === 'number') {
            contentKey = contentKey.replace(FlowConstants.VALUE_PLACEHOLDER, `${value}`);
            icon = icon.replace(FlowConstants.VALUE_PLACEHOLDER, `${value}`);
        }
        // TODO: Handle boolean value (example is needed)

        if (!contentData) {
            return {
                ...slot.tooltip,
                icon,
                contentKey: this.translate.instant(contentKey)
            };
        }

        const params = TranslationUtils.sanitizeTranslationParams(this.contextModel.processJsonLogic(contentData));

        return {
            ...slot.tooltip,
            icon,
            contentKey: this.translate.instant(contentKey, params)
        };
    }
}
